import React, { useState } from 'react'
import ClientModal from './ClientModal'

function CalenderCard({data,amount,contribution, setIsModalOpen}) {
  return (
  
      <div className={`calender-card ${!data?.date && 'empty-box'}`} onClick={()=>{
        console.log(contribution)
            if(contribution?.type==='my' &&contribution?.card==='case'){
              setIsModalOpen(data?.date)
            }
        }} >
        <div>{(amount==='amount' && parseInt(data?.count)>=0) ? new Intl.NumberFormat("en-IN", {
                style: "currency",
                currency: "INR",
                minimumFractionDigits: Number.isInteger(parseFloat(data?.count))?0:1,
                maximumFractionDigits: Number.isInteger(parseFloat(data?.count))?0:1,
              }).format(data?.count) :data?.count} </div>
        <div>{data?.date} </div>
      </div>



  )
}

export default CalenderCard
